export enum FormType {
   General = "general",
   Specific = "specific"
}